import { lazy } from 'react';
import { Route, Routes } from 'react-router';

import B2cPage from 'pages/b2c';

const AppLayout = lazy(() => import('shared/components/app-layout'));
const CredentialPage = lazy(() => import('pages/credential'));

export default function App () {
  return (
    <Routes>
      <Route element={<B2cPage />}
        path='b2c' />
      <Route element={<AppLayout />}
        path='*'>
        <Route element={<CredentialPage />}
          index />
      </Route>
    </Routes>
  );
}
